export default __webpack_public_path__ + "static/media/arms.b39c7df9.ogg";